<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table voucher-list-table">
        <thead>
        <tr>
          <th class="col-date">Date</th>
          <th class="col-voucher">Voucher No</th>
          <th>Description</th>
          <th class="col-amount">Amount</th>
          <th>Status</th>
          <th>Attachments</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in journals" :key="i">
          <td class="col-date">
            <span class="fw-bold">{{ item.date }}</span>
          </td>
          <td class="col-voucher">{{ item.voucher_no }}</td>
          <td> {{ item.note }}</td>
          <td class="col-amount"> {{ commaFormat(item.total_amount) }}</td>
          <td> {{ startCase(item.status) }}</td>
          <td>
            <button v-if="item.attachments.length > 0" class="btn btn-primary btn-sm"
                    style="cursor: pointer"
                    @click="viewAttachments(item.attachments)"
            >
              <i class="fas fa-eye"></i>
              View
            </button>
            <span v-else class="badge btn-danger">
              No attachments
            </span>
          </td>
          <td>
              <div class="btn-group">
                  <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm rounded-2"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style="cursor: pointer;"
                  >
                      <i class="fas fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                      <li v-if="canEdit(item.status)">
                          <a class="dropdown-item"
                             href="#"
                             @click.prevent="goToEdit(item.id)">
                              <i class="fas fa-edit me-1"></i> Edit
                          </a>
                      </li>
                      <li v-if="canPrint(item.status)">
                          <a class="dropdown-item"
                             href="#"
                             @click.prevent="goToPrint(item.id)">
                              <i class="fas fa-print me-1"></i> Print
                          </a>
                      </li>
                  </ul>
              </div>
          </td>
        </tr>

        </tbody>
      </table>
      <p v-if="!journals.length" class="text-center mt-5">No data</p>

    </div>

    <ViewAttachment
      ref="viewAttachmentRef"
      :attachments="modalAttachments"
    />
  </div>
</template>

<script setup>

//imports
import {useStore} from 'vuex'
import figureFormatter from '@/services/utils/figureFormatter'
import {computed, ref, onMounted} from "vue";
import {useRoute, useRouter} from "vue-router";
import ViewAttachment from "@/components/molecule/ngo/journal/ViewAttachmentModal"
import ngoPdfPrinter from '@/services/utils/ngoPdfPrinter';
import handleCompany from "@/services/modules/company";
import handleBarcode from "@/services/modules/barcode";
import handleJournal from "@/services/modules/journal";
import { startCase } from 'lodash';

const companyInfo = ref({});
const journal = ref({});
const barcodeQuery = ref('');
const barcode = ref('');
const qrcode = ref('');
const {commaFormat} = figureFormatter()
const $store = useStore();
const $route = useRoute();
const $router = useRouter();
const modalAttachments = ref([]);
const viewAttachmentRef = ref();
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = ngoPdfPrinter();
const { fetchBarcode } = handleBarcode();
const {fetchJournal} = handleJournal();

onMounted(() => {
  fetchCompanyInfo($route.params.companyId).then( (res) => {
    companyInfo.value = res.data;
  }).catch( (err) => {
    console.log(err);
  })
})

const journals = computed(() => {
  return $store.getters["journal/getJournals"]
})

//methods
const canEdit = (status) => ['returned', 'return', 'pending', 'pending_approval'].includes(status)
const canPrint = (status) => status !== 'rejected'

const goToPrint = (id) => {
  const companyQuery = `?company_id=${$route.params.companyId}`;
  fetchJournal(id, companyQuery).then( (res) => {
    if(res){
      journal.value = res.data;
      let qrcodeData = JSON.stringify({
        ref_no: journal.value.voucher_no,
        ref_date: journal.value.date,
        created_by: journal.value.user.name,
        created_date_time: formatDate(new Date())
      })
      barcodeQuery.value = `?code=${journal.value.voucher_no}&qrcode=${qrcodeData}`;
    }}).then (() => {
    fetchBarcode(barcodeQuery.value).then( (res) => {
      barcode.value = res.barcode;
      qrcode.value = res.qrcode;
    }).then( () => {
      exportToPDF(companyInfo.value, journal.value, barcode.value, qrcode.value, 'journal');
    })}).catch((err) => {
      console.log('Something went wrong');
  })
}

const formatDate = (date) => {
  var formattedDate = date.toISOString().split('T')[0];
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var amOrPm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
  return formatToDdMmYy(formattedDate) + ' ' + formattedTime
}

const formatToDdMmYy = (date) => {
  var dat = date.split('-');
  return `${dat[2]}-${dat[1]}-${dat[0]}`;
}

const goToEdit = (id) => {
  let params = {
    companyId: $route.params.companyId,
    moduleId : $route.params.moduleId,
    menuId   : $route.params.menuId,
    pageId   : $route.params.pageId,
    journalId: id
  }

  let query = {
    start: $route.query.start,
    end  : $route.query.end
  }

  $router.push({
    name  : 'edit-journal-np',
    params: params,
    query : query,
  })
}

const viewAttachments = (attachments) => {
  modalAttachments.value = [];
  modalAttachments.value = attachments;
  viewAttachmentRef?.value.toggleModal();
}
</script>

<style scoped>
.voucher-list-table .col-date,
.voucher-list-table .col-voucher,
.voucher-list-table .col-amount {
    white-space: nowrap;
}
.voucher-list-table .col-date {
    min-width: 7.5rem;
}
.voucher-list-table .col-voucher {
    min-width: 8.5rem;
}
.voucher-list-table .col-amount {
    min-width: 9.5rem;
    text-align: right;
}
.voucher-list-table td {
    vertical-align: middle;
}
.table-responsive {
    overflow-x: auto;
    overflow-y: visible;
}
.dropdown-menu.show {
    z-index: 1055;
}
</style>
